export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يتخطى"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نجح تسجيل الخروج"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة غير صالح"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العودة إلى صفحة الدخول"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرجوع إلى النظرة العامة"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العودة إلى صفحة الدخول"])}
        }
      },
      "ar-DZ": {
        "skipSetupThisTime": {
          
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز التوثيق غير صالح"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرجوع إلى صفحة الدخول"])}
        },
        "switchMethod": {
          
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرجوع إلى صفحة الدخول"])}
        }
      },
      "ar-EG": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يتخطى"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نجح تسجيل الخروج"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرمز التوثيقي غير صالح"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العودة إلى صفحة الدخول"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرجوع إلى النظرة العامة"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العودة إلى صفحة الدخول"])}
        }
      },
      "ar-LB": {
        "skipSetupThisTime": {
          
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرمز التوثيقي غير صالح"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العودة إلى صفحة الدخول"])}
        },
        "switchMethod": {
          
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العودة إلى صفحة الدخول"])}
        }
      },
      "ar-MA": {
        "skipSetupThisTime": {
          
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق غير صالح"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العودة إلى صفحة الدخول"])}
        },
        "switchMethod": {
          
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العودة إلى صفحة الدخول"])}
        }
      },
      "ar-SA": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يتخطى"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نجح تسجيل الخروج"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز التحقق غير صالح"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عودة إلى صفحة تسجيل الدخول"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرجوع إلى النظرة العامة"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عودة إلى صفحة تسجيل الدخول"])}
        }
      },
      "ar-SY": {
        "skipSetupThisTime": {
          
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق غير صالح"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العودة إلى صفحة الدخول"])}
        },
        "switchMethod": {
          
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العودة إلى صفحة الدخول"])}
        }
      },
      "ar-TN": {
        "skipSetupThisTime": {
          
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كود التوثيق غير صالح"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العودة إلى صفحة الدخول"])}
        },
        "switchMethod": {
          
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العودة إلى صفحة الدخول"])}
        }
      },
      "bg-BG": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пропускане"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Излизането беше успешно"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване е невалиден"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Обратно към страницата за вход"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Назад към общ преглед"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Обратно към страницата за вход"])}
        }
      },
      "bs-BA": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preskoči"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odjava je bila uspješna"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod za autentifikaciju je nevažeći"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazad na stranicu za prijavu"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Povratak na pregled"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazad na stranicu za prijavu"])}
        }
      },
      "cs-CZ": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přeskočit"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odhlášení bylo úspěšné"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód je neplatný"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zpět na přihlašovací stránku"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zpět na přehled"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zpět na přihlašovací stránku"])}
        }
      },
      "da-DK": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["spring over"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Det lykkedes at logge ud"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden er ugyldig"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tilbage til loginsiden"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tilbage til oversigt"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tilbage til loginsiden"])}
        }
      },
      "de-DE": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Überspringen"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Abmeldung war erfolgreich"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode ist ungültig."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurück zur Anmeldeseite"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurück zur Übersicht"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurück zur Anmeldeseite"])}
        }
      },
      "de-AT": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Überspringen"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Abmeldung war erfolgreich"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode ist ungültig."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurück zur Anmeldeseite"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurück zur Übersicht"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurück zur Anmeldeseite"])}
        }
      },
      "de-CH": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Überspringen"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Abmeldung war erfolgreich"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode ist ungültig."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurück zur Anmeldeseite"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurück zur Übersicht"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurück zur Anmeldeseite"])}
        }
      },
      "de-LU": {
        "skipSetupThisTime": {
          
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode ist ungültig."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurück zur Anmeldeseite"])}
        },
        "switchMethod": {
          
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurück zur Anmeldeseite"])}
        }
      },
      "el-GR": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Παράλειψη"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Η αποσύνδεση ήταν επιτυχής"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός επαλήθευσης είναι άκυρος"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιστροφή στη σελίδα σύνδεσης"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιστροφή στην επισκόπηση"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιστροφή στη σελίδα σύνδεσης"])}
        }
      },
      "el-CY": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Παράλειψη"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Η αποσύνδεση ήταν επιτυχής"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός επαλήθευσης είναι άκυρος"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιστροφή στη σελίδα σύνδεσης"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιστροφή στην επισκόπηση"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιστροφή στη σελίδα σύνδεσης"])}
        }
      },
      "en-GB": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skip"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful Action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logging out was successful"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code is invalid."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to Login Page"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to overview"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to Login Page"])}
        }
      },
      "en-IE": {
        "skipSetupThisTime": {
          
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful Action"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code is invalid."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to Login Page"])}
        },
        "switchMethod": {
          
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to Login Page"])}
        }
      },
      "en-US": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skip"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful Action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logging out was successful"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code is invalid."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to Login Page"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to overview"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to Login Page"])}
        }
      },
      "es-ES": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saltar"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se ha cerrado la sesión correctamente"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El código de autenticación es inválido"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la página de inicio de sesión"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atrás"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la página de inicio de sesión"])}
        }
      },
      "et-EE": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jäta vahele"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Väljalogimine õnnestus"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood on kehtetu"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tagasi sisselogimise lehele"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tagasi ülevaate juurde"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tagasi sisselogimise lehele"])}
        }
      },
      "fi-FI": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ohita"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uloskirjautuminen onnistui"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi on virheellinen"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Takaisin kirjautumissivulle"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Takaisin yleiskatsaukseen"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Takaisin kirjautumissivulle"])}
        }
      },
      "fr-BE": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sauter"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La déconnexion a réussi"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est invalide"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retour à la page de connexion"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retour à la page d'accueil"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retour à la page de connexion"])}
        }
      },
      "fr-CH": {
        "skipSetupThisTime": {
          
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est invalide"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retour à la page de connexion"])}
        },
        "switchMethod": {
          
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retour à la page de connexion"])}
        }
      },
      "fr-FR": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sauter"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La déconnexion a réussi"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est invalide"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retour à la page de connexion"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retour à la page d'accueil"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retour à la page de connexion"])}
        }
      },
      "fr-LU": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sauter"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La déconnexion a réussi"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est invalide"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retour à la page de connexion"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retour à la page d'accueil"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retour à la page de connexion"])}
        }
      },
      "ga-IE": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scipeáil"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["D'éirigh leis an logáil amach"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tá an cód fíordheimhnithe neamhbhailí"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ar ais go dtí an leathanach logáil isteach"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ar ais go forbhreathnú"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ar ais go dtí an leathanach logáil isteach"])}
        }
      },
      "he-IL": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לדלג"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ההתנתקות הצליחה"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד האימות אינו חוקי"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חזרה לדף הכניסה"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חזרה לסקירה כללית"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חזרה לדף הכניסה"])}
        }
      },
      "hi-IN": {
        "skipSetupThisTime": {
          
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सफल कार्रवाई"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रमाणीकरण कोड अमान्य है"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["त्रुटि"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["लॉगिन पेज पर वापस जाएं"])}
        },
        "switchMethod": {
          
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["लॉगिन पेज पर वापस जाएं"])}
        }
      },
      "hr-HR": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preskočiti"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odjava je bila uspješna"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod za autentifikaciju je nevažeći"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vratite se na stranicu za prijavu"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Povratak na pregled"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vratite se na stranicu za prijavu"])}
        }
      },
      "hu-HU": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kihagy"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A kijelentkezés sikeres volt"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Az hitelesítési kód érvénytelen"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vissza a bejelentkezési oldalra"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vissza az áttekintéshez"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vissza a bejelentkezési oldalra"])}
        }
      },
      "it-CH": {
        "skipSetupThisTime": {
          
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione di successo"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il codice di autenticazione non è valido"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Torna alla pagina di accesso"])}
        },
        "switchMethod": {
          
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Torna alla pagina di accesso"])}
        }
      },
      "it-IT": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salta"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La disconnessione ha avuto successo"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il codice di autenticazione non è valido"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Torna alla pagina di login"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Torna alla panoramica"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Torna alla pagina di login"])}
        }
      },
      "ja-JP": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["スキップ"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ログアウト成功"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードが無効です"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ログインページに戻ります"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["概要に戻る"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ログインページに戻ります"])}
        }
      },
      "ko-KR": {
        "skipSetupThisTime": {
          
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["성공적인 액션"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["인증 코드가 유효하지 않습니다"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["오류"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["로그인 페이지로 돌아가기"])}
        },
        "switchMethod": {
          
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["로그인 페이지로 돌아가기"])}
        }
      },
      "lt-LT": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Praleisti"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atsijungimas buvo sėkmingas"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijos kodas netinkamas"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Grįžti į prisijungimo puslapį"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Grįžti į apžvalgą"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Grįžti į prisijungimo puslapį"])}
        }
      },
      "lv-LV": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izlaist"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atteikšanās sekmīga"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods ir nederīgs"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atgriezties uz pieteikšanās lapu"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atgriezties uz kopsavilkumu"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atgriezties uz pieteikšanās lapu"])}
        }
      },
      "mt-MT": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aqbeż"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Id-dereġistrazzjoni kienet suċċess"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta' awtentiċità mhux validu"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lura għall-Paġna tal-Login"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lura għall-ħarsa ġenerali"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lura għall-Paġna tal-Login"])}
        }
      },
      "nb-NO": {
        "skipSetupThisTime": {
          
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden er ugyldig"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Feil"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tilbake til innloggingssiden"])}
        },
        "switchMethod": {
          
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tilbake til innloggingssiden"])}
        }
      },
      "nl-BE": {
        "skipSetupThisTime": {
          
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De verificatiecode is ongeldig"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terug naar de inlogpagina"])}
        },
        "switchMethod": {
          
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terug naar de inlogpagina"])}
        }
      },
      "nl-NL": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overslaan"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uitloggen is gelukt"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De verificatiecode is ongeldig"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terug naar inlogpagina"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terug naar overzicht"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terug naar inlogpagina"])}
        }
      },
      "pl-PL": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pomiń"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wylogowanie powiodło się"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniania jest nieprawidłowy"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Powrót do strony logowania"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Powrót do przeglądu"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Powrót do strony logowania"])}
        }
      },
      "pt-PT": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ignorar"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout bem-sucedido"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O código de autenticação é inválido"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voltar à página de início de sessão"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voltar ao menu principal"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voltar à página de início de sessão"])}
        }
      },
      "ro-RO": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ignorare"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deconectarea a avut succes"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare este invalid"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Înapoi la pagina de conectare"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Înapoi la prezentarea generală"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Înapoi la pagina de conectare"])}
        }
      },
      "ru-RU": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пропустить"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выход из системы прошел успешно"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации недействителен"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Назад на страницу входа"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вернуться к общим сведениям"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Назад на страницу входа"])}
        }
      },
      "sk-SK": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preskočiť"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odhlásenie bolo úspešné"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikačný kód je neplatný"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Späť na prihlasovaciu stránku"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Späť na prehľad"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Späť na prihlasovaciu stránku"])}
        }
      },
      "sl-SI": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preskoči"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odjava je uspela"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za overitev je neveljavna"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazaj na prijavo"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazaj na pregled"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazaj na prijavo"])}
        }
      },
      "sv-SE": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hoppa över"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utloggningen lyckades"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden är ogiltig"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Återvänd till inloggningssidan"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tillbaka till översikt"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Återvänd till inloggningssidan"])}
        }
      },
      "th-TH": {
        "skipSetupThisTime": {
          
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["การดำเนินการที่ประสบความสำเร็จ"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["รหัสการตรวจสอบไม่ถูกต้อง"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ความผิดพลาด"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["กลับไปยังหน้าล็อกอิน"])}
        },
        "switchMethod": {
          
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["กลับไปยังหน้าล็อกอิน"])}
        }
      },
      "tr-CY": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atla"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Çıkış başarılı oldu"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu geçersiz"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oturum açma sayfasına dön"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Genel bakışa dön"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oturum açma sayfasına dön"])}
        }
      },
      "tr-TR": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atla"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Çıkış başarılı oldu"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doğrulama kodu geçersiz"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oturum açma sayfasına dön"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Genel bakışa dön"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oturum açma sayfasına dön"])}
        }
      },
      "uk-UA": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Überspringen"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успішна дія"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вихід успішно виконано"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код автентифікації недійсний"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Помилка"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Повернутися до сторінки входу"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurück zur Übersicht"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Повернутися до сторінки входу"])}
        }
      },
      "vi-VN": {
        "skipSetupThisTime": {
          
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hành động thành công"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mã xác thực không hợp lệ"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lỗi"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quay lại trang đăng nhập"])}
        },
        "switchMethod": {
          
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quay lại trang đăng nhập"])}
        }
      },
      "zh-CN": {
        "skipSetupThisTime": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["跳过"])}
        },
        "notification": {
          "logout": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["注销成功"])}
            }
          },
          "authenticate": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["认证代码无效"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            }
          }
        },
        "goBackToLogin": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回登录页面"])}
        },
        "switchMethod": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回概览"])}
        },
        "startOver": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回登录页面"])}
        }
      }
    }
  })
}
